<template>
  <el-dialog 
    :modal="true"
    :modal-append-to-body="true"
    title="提示"
    :visible.sync="show"
    :close-on-click-modal="false"
    :show-close="false"
    :close-on-press-escape="true"
    :before-close="clickCancel"
    class="outer_dialog">
    <div class="outer_wrap">
      <i class="el-icon-warning" @click="innerVisible = true"></i>
      <p>系统升级中，请稍后再试！</p>
    </div>
    <el-dialog
      :modal="true"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      :show-close="false"
      :close-on-press-escape="true"
      :before-close="innerclickCancel"
      title="继续"
      :visible.sync="innerVisible"
      append-to-body 
      class="inner_dialog">
      <div class="inner_wrap">
        <el-input v-model="innerValue"></el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="innerclickCancel">取消</el-button>
        <el-button type="primary" @click="innerclickConfirm">跳转</el-button>
      </div>
    </el-dialog>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="clickCancel">知道了</el-button>
    </div>
  </el-dialog>
</template>
<script>
import './dialog.scss'
export default {
  props: {
    showModalconfirm:{
      type:Boolean,
      default:false
    },
  },
  data(){
    return{
      show: false,
      innerVisible: false,
      innerValue: ""
    }
  },
  watch:{
    showModalconfirm(val){
      this.show = val
    },
  },
  methods: {
    clickCancel(){
      this.show = false
      this.$emit('onclickCancel');
    },
    innerclickCancel(){
      this.innerVisible = false
    },
    innerclickConfirm() {
      this.innerVisible = false
      this.$emit('innerclickConfirm', this.innerValue);
    },
  }
}
</script>


// WEBPACK FOOTER //
// src/components/dialog/renewDialog/index.vue